import React from "react";
import { useSelector } from "react-redux";
//common components
import { AppState } from "../../config/redux/reducers";
import AppConstants from "../../constants";

//redux
import {
  fetchDriversList,
  exportToExcel,
  createCodReceiptDraft,
  resetExportInitiated,
} from "./redux/stdCodPortalSlice";
import {
  createPayloadToFetchDriversList,
  codPortalDriversDataTransform,
} from "../../mocks/stdCodPortal/response.transforms";

import CODDriverDetails from "./stdCodDriverDetails";
import CODUploadReceipt from "./stdCodUploadReceipt";
import CODPortalBase from "CODPortal/shared/codPortalBaseComponent";



const StandardCodPortal = () => {
  const {
    driversData,
    loading,
    driversFiltersDropdowns,
    error,
    errorCode,
    excelLoading,
    exportError,
    isAmtCollected,
    exportInitiated,
    reportId,
  } = useSelector((state: AppState) => state.stdCodPortal);


  return (
    <CODPortalBase
      reduxStates={{
        driversData: driversData,
        loading,
        driversFiltersDropdowns: driversFiltersDropdowns,
        error,
        errorCode,
        excelLoading,
        exportError,
        isAmtCollectedForOrders: isAmtCollected,
        exportInitiated,
        reportId,
      }}
      transforms={{
        createPayloadToFetchDriversList,
        driversDataTransform: codPortalDriversDataTransform,
      }}
      actions={{
        fetchDriversList,
        exportToExcel,
        createReceiptDraft: createCodReceiptDraft,
        resetExportInitiated,
      }}
      tableWrapperDataConstant={AppConstants.COD_RECON_CONSTANTS}
      DriverDetails={CODDriverDetails}
      UploadReceipt={CODUploadReceipt}
    />
  );
};

export default StandardCodPortal;
